/**
 * Wrapper per i tipi primitivi passati direttamente come BODY nelle request Http
 */
export class BodyRequest<Type> {
    constructor(public data: Type) {
    }
}
